import { useTranslation } from 'react-i18next';
import { CalendarDays, Clock, Users } from 'lucide-react';
import { cn } from '@/lib/utils';

// The chosen service (name · duration · price) with "Change", which goes back
// to the booking page.
export function ServiceChip({ name, meta, group, onChange }: { name: string; meta: string; group?: boolean; onChange?: () => void }) {
  const { t } = useTranslation('bookingPage');
  return (
    <div className="flex items-center gap-3 rounded-2xl border border-line bg-surface px-3.5 py-3" data-testid="service-chip">
      <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] bg-brand-50">
        {group ? <Users className="h-[18px] w-[18px] text-brand-500" /> : <Clock className="h-[18px] w-[18px] text-brand-500" />}
      </span>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="truncate text-[15px] font-semibold text-ink">{name}</span>
        <span className="text-[13px] tabular-nums text-soft">{meta}</span>
      </div>
      {onChange && (
        <button type="button" onClick={onChange} className="shrink-0 px-1 py-3 text-[14px] font-medium text-brand-500 hover:text-brand-700">
          {t('steps.change')}
        </button>
      )}
    </div>
  );
}

// Step 2: the chosen date and time, with "Change" back to step 1.
export function WhenChip({ title, detail, onChange, tone = 'brand' }: { title: string; detail?: string; onChange: () => void; tone?: 'brand' | 'plain' }) {
  const { t } = useTranslation('bookingPage');
  return (
    <div
      className={cn('flex items-center gap-3 rounded-2xl px-3.5 py-3', tone === 'brand' ? 'bg-brand-50' : 'border border-line bg-surface')}
      data-testid="when-chip"
    >
      <CalendarDays className={cn('h-[18px] w-[18px] shrink-0', tone === 'brand' ? 'text-brand-500' : 'text-soft')} />
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="text-[15px] font-semibold tabular-nums text-ink">{title}</span>
        {detail && <span className="truncate text-[13px] text-soft">{detail}</span>}
      </span>
      <button type="button" onClick={onChange} className="shrink-0 px-1 py-2.5 text-[14px] font-medium text-brand-500 hover:text-brand-700">
        {t('steps.change')}
      </button>
    </div>
  );
}
